import { useState } from 'react'
import { alertService } from '../services/AlertService';
import { handleError } from '../model/handleError';
import ContenutiUtentiService from '../services/ContenutiUtentiService/ContenutiUtentiService';

const useCorsi = () => {
    const [loadingState, setLoadingState] = useState({
        isLoadingIniziaContenuto: false,
        isLoadingVerificaStatoContenuto: false,
        isLoadingVerificaCompletamenti: false,
        isLoadingGetUrl: false,
        isLoadingSalvaTest:false
    });

  
    const iniziaContenuto = async (data) => {
      setLoadingState({ ...loadingState, isLoadingIniziaContenuto: true });
      try {
        let response = await ContenutiUtentiService.iniziaContenuto(data);
        return response
      } catch (error) {
        handleError(error)
      } finally {
        setLoadingState({ ...loadingState, isLoadingIniziaContenuto: false });
      }
  }

    const verificaStatoContenuto = async (data) => {
      setLoadingState({ ...loadingState, isLoadingVerificaStatoContenuto: true });
      try {
        let response = await ContenutiUtentiService.verificaStatoContenuto(data);
        return response
      } catch (error) {
        handleError(error)
      } finally {
        setLoadingState({ ...loadingState, isLoadingVerificaStatoContenuto: false });
      }
  }

  const verificaCompletamenti = async (data) => {
    setLoadingState({ ...loadingState, isLoadingVerificaCompletamenti: true });
    try {
      let response = await ContenutiUtentiService.verificaCompletamenti(data);
      return response
    } catch (error) {
      handleError(error)
    } finally {
      setLoadingState({ ...loadingState, isLoadingVerificaCompletamenti: false });
    }
  }

  const getUrl = async (data) => {
    setLoadingState({ ...loadingState, isLoadingGetUrl: true });
    try {
      let response = await ContenutiUtentiService.getUrl(data);
      return response
    } catch (error) {
     /*  handleError(error) */
    } finally {
      setLoadingState({ ...loadingState, isLoadingGetUrl: false });
    }
  }

  const salvaTest = async (data) => {
    setLoadingState({ ...loadingState, isLoadingSalvaTest: true });
    try {
      let response = await ContenutiUtentiService.salvaTest(data);
      return response
    } catch (error) {
      handleError(error)
    } finally {
      setLoadingState({ ...loadingState, isLoadingSalvaTest: false });
    }
  }

  return {
    loadingStateContenutiUtenti: loadingState,
    iniziaContenuto,
    verificaStatoContenuto,
    verificaCompletamenti,
    getUrl,
    salvaTest
  };      
}

export default useCorsi;